import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './index.css'
import './navbar_controller.js'
import store from './store'
// import './actions.js'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
